import { apiFetchWithdrawAccount, apiGetColumbiaBankList } from '@/api/imee.js'
import { bankType, bankListID, bankListMA, bankListVN, columbiaList1, columbiaList2 } from './constant'
import { pageCssVars } from './z-style-cfg.js'

// 国家代码 ID是印尼, TR是土耳其 MA是摩洛哥 CO是哥伦比亚
export default {
  mixins: [pageCssVars],
  data() {
    const query = this.$route.query
    return {
      bankType,
      walletType: query.walletType,
      icon: query.icon || null,
      locaFlag: query.locaFlag || null,
      locaCode: query.locaCode || null,
      withdrawalMethod: query.withdrawalMethod || null,
      minDollarAmount: query.minDollarAmount || null,
      // submit
      accountName: '',
      accountId: '',
      accountAddress: '',
      change: query.change || null,
      cfgId: '',
      bankCode: '',
      userPhoneNumber: '',
      // 哥伦比亚submit
      columbiaForm: {
        accountName: '',
        accountAddress: '',
        idNumber: '',
        email: '',
        lastName: '',
        phoneNumber: '',
        idType: '',
        accountType: '',
        accountId: '',
        bankCode: '',
      },
      columbiaList1,
      columbiaList2,
      // 银行
      pickerValue: '',
      showBankPicker: false,
      bankText: '',
      bankList: [],
      // pix 填写的格式
      // 12345678900 或者 123.456.789-00
      showDialog: false,
      // picker
      showTypePicker1: false,
      showTypePicker2: false,
      pickerTypeValue1: '',
      pickerTypeValue2: '',
    }
  },
  mounted() {
    if (this.locaCode === 'MA') {
      this.bankList = bankListMA
    }
    if (this.locaCode === 'ID') {
      this.bankList = bankListID
    }
    if (this.locaCode === 'VN') {
      this.bankList = bankListVN
    }
    if (this.locaCode === 'CO') {
      this.handleGetColumbiaBankList()
    }

    if (this.change) {
      this.fetchWithdrawAccount()
    }
  },
  methods: {
    customMaxLen(event, max, key) {
      if (event.target.value && event.target.value.length > max) {
        this[key] = event.target.value.slice(0, max)
      }
    },
    onlyNum(event, key) {
      this[key] = event.target.value.replace(/[^0-9]/g, '')
    },
    onlyNumKeypress(event) {
      const charCode = event.keyCode || event.which
      if (charCode < 48 || charCode > 57) {
        event.preventDefault()
      }
    },
    onlyNumOrLetter(event, key) {
      this[key] = event.target.value.replace(/[^a-zA-Z0-9]/g, '')
    },
    only14digitNum(event, key) {
      this.onlyNum(event, key)
      this.customMaxLen(event, 14, key)
    },
    // 获取银行列表（哥伦比亚）
    handleGetColumbiaBankList() {
      apiGetColumbiaBankList().then((res) => {
        if (res && !res.error) {
          if (Array.isArray(res)) {
            const list = res.map((v) => {
              return {
                text: v.bankName || '',
                value: v.bankCode || '',
              }
            })
            this.bankList = list

            // 回显银行
            if (this.bankCode) {
              const target = this.bankList.find((v) => v.value === this.bankCode) || {}
              this.bankText = target.text || ''
            }
          }
        }
      })
    },

    // 获取提现账户方式-详情
    fetchWithdrawAccount() {
      apiFetchWithdrawAccount().then((res) => {
        if (res && !res.error) {
          if (Array.isArray(res)) {
            res.forEach((item) => {
              if (item.withdrawalMethod === this.withdrawalMethod) {
                this.cfgId = item.cfgId
                this.bankCode = item.bankCode || ''
                this.accountId = item.accountId
                this.accountName = item.accountName

                // 银行 - ID MA VN
                if (this.bankType.includes(this.withdrawalMethod)) {
                  // 摩洛哥
                  if (this.locaCode === 'MA') {
                    const target = bankListMA.find((son) => son.value === item.bankCode) || {}
                    this.bankText = target.text || ''
                  }
                  // 印尼
                  if (this.locaCode === 'ID') {
                    this.userPhoneNumber = item.phoneNumber
                    const target = bankListID.find((son) => son.value === item.bankCode) || {}
                    this.bankText = target.text || ''
                  }
                  // 越南
                  if (this.locaCode === 'VN') {
                    this.userPhoneNumber = item.phoneNumber
                    const target = bankListVN.find((son) => son.value === item.bankCode) || {}
                    this.bankText = target.text || ''
                  }
                }

                // Papara
                if (this.withdrawalMethod === 'Papara') {
                  this.userPhoneNumber = item.phoneNumber
                }

                // Transfer bancaria - 哥伦比亚
                if (this.withdrawalMethod === 'Transfer bancaria') {
                  if (this.locaCode === 'CO') {
                    this.columbiaForm.accountAddress = item.accountAddress || ''
                    this.columbiaForm.accountId = item.accountId || ''
                    this.columbiaForm.accountName = item.accountName || ''
                    this.columbiaForm.accountType = item.accountType || ''
                    this.columbiaForm.bankCode = item.bankCode || ''
                    this.columbiaForm.email = item.email || ''
                    this.columbiaForm.idNumber = item.idNumber || ''
                    this.columbiaForm.idType = item.idType || ''
                    this.columbiaForm.lastName = item.lastName || ''
                    this.columbiaForm.phoneNumber = item.phoneNumber || ''
                    // 回显ID类型
                    const target1 = columbiaList1.find((v) => v.value === item.idType) || {}
                    this.pickerTypeValue1 = target1.text || ''
                    // 回显账户类型
                    const target2 = columbiaList2.find((v) => v.value === item.accountType) || {}
                    this.pickerTypeValue2 = target2.text || ''
                    // 回显银行
                    const target3 = this.bankList.find((v) => v.value === item.bankCode) || {}
                    this.bankText = target3.text || ''
                  }
                }

                // Transfiya bancaria - 哥伦比亚
                if (this.withdrawalMethod === 'Transfiya bancaria' && this.locaCode === 'CO') {
                  this.columbiaForm.accountId = item.accountId || ''
                  this.columbiaForm.accountName = item.accountName || ''
                  this.columbiaForm.bankCode = item.bankCode || ''
                  this.columbiaForm.idNumber = item.idNumber || ''
                  this.columbiaForm.idType = item.idType || ''
                  // 回显ID类型
                  const target1 = columbiaList1.find((v) => v.value === item.idType) || {}
                  this.pickerTypeValue1 = target1.text || ''
                  // 回显银行
                  const target3 = this.bankList.find((v) => v.value === item.bankCode) || {}
                  this.bankText = target3.text || ''
                }

                // USDT(BINANCE)
                if (this.withdrawalMethod === 'USDT(BINANCE)') {
                  this.accountAddress = item.accountAddress || ''
                }

                // USDT(TRC20/BEP20)
                if (this.withdrawalMethod === 'USDT(TRC20/BEP20)') {
                  this.accountAddress = item.accountAddress || item.accountId
                }

                // PIX - 巴西手机号
                if (this.withdrawalMethod === 'PIX' && this.locaCode === 'BR' && item.phoneNumber) {
                  this.phoneNumber = item.phoneNumber
                  if (typeof this.formatBrazilPhoneInput === 'function') {
                    this.phoneNumberDisplay = this.formatBrazilPhoneInput(item.phoneNumber)
                  }
                }
              }
            })
          }
        }
      })
    },

    // 选中银行卡（印尼，摩洛哥，哥伦比亚）
    handleBankPickerConfirm(item) {
      this.bankText = item.text
      this.bankCode = item.value
      this.columbiaForm.bankCode = item.value
      this.showBankPicker = false
    },

    // 选中类型1（哥伦比亚）
    handleTypePickerConfirm1(item) {
      this.pickerTypeValue1 = item.text
      this.columbiaForm.idType = item.value
      this.columbiaForm.idNumber = ''
      this.showTypePicker1 = false
    },

    // 选中类型2（哥伦比亚）
    handleTypePickerConfirm2(item) {
      this.pickerTypeValue2 = item.text
      this.columbiaForm.accountType = item.value
      this.showTypePicker2 = false
    },

    jumpWithdrawal() {
      const timer = setTimeout(() => {
        clearTimeout(timer)
        this.$router.replace({
          path: '/withdrawal',
          query: {
            withdrawalMethod: this.withdrawalMethod,
            icon: this.icon,
            minPrice: this.minDollarAmount,
            walletType: this.walletType,
          },
        })
      }, 500)
    },
  },
}
